import React from 'react'

import { Comments } from 'components/Comments'
import BaseModal from 'components/Modals/BaseModal'

const CommentsModal = ({ resourceId, resourceType }) => {
  return (
    <BaseModal title="components.comments.COMMENTS_MODAL">
      <Comments resourceId={resourceId} resourceType={resourceType} />
    </BaseModal>
  )
}

export default CommentsModal
